import React from 'react'
import styled from 'styled-components'

import LineTimesIcon from 'components/Luxkit/Icons/line/LineTimesIcon'
import BaseBookmarkButton from 'tripPlanner/components/Bookmark/Common/BaseBookmarkButton'
import DeleteTripItem from 'tripPlanner/components/TripModal/TripItems/DeleteTripItem'
import useOpenModal from 'tripPlanner/hooks/View/useOpenModal'
import { TripItem } from 'tripPlanner/types/tripItem'

const BookmarkButton = styled(BaseBookmarkButton)`
  @media print {
    display: none;
  }
`

interface Props {
  item: TripItem
}

function SavedItemRemoveButton({ item }: Props) {
  const openModal = useOpenModal()
  const deleteItem = () =>
    openModal(DeleteTripItem, { item }, { height: 'auto' })

  return (
    <BookmarkButton onClick={deleteItem} endIcon={<LineTimesIcon />} isSaved>
      Saved
    </BookmarkButton>
  )
}

export default SavedItemRemoveButton
